<template>
  <MasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p>
          {{ $t("text.addProduct.title") }}
        </p>
      </div>
      <div class="cover">
        <div class="personal">
          <label class="uplift">{{
            $t("text.addProduct.productInformation")
          }}</label>
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.addProduct.product") }}
                </span>
              </label>
              <div class="input__block" ref="lname_input">
                <select v-model="selected">
                  <option
                    :value="$t('text.addProduct.selectAProduct')"
                    selected
                    disabled
                  >
                    {{ $t("text.addProduct.selectAProduct") }}
                  </option>
                  <option
                    :value="prod"
                    v-for="(prod, index) in prodArray"
                    :key="index"
                  >
                    {{ prod.productName }}
                  </option>
                </select>
              </div>
              <div ref="lname_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.addProduct.price") }}
                </span>
              </label>
              <div class="input__block" ref="c_inp">
                <input
                  type="number"
                  :placeholder="$t('text.addProduct.price')"
                  class="form-control"
                  v-model="price"
                />
              </div>
              <div ref="c_err"></div>
            </div>
          </div>
          <div class="row">
            <div
              class="input__group__block mt-4 col-md-6"
              style="margin-left: 0"
            >
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.addProduct.state") }}
                </span>
              </label>
              <div class="input__block">
                <select v-model="state">
                  <option :value="st" v-for="(st, i) in states" :key="i">
                    {{ st.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="contact" v-if="LGAs">
          <label class="uplift">{{ $t("text.addProduct.localGovArea") }}</label>
          <div class="row" v-for="(local, ind) in localGovernment" :key="ind">
            <div
              class="input__group__block mt-4 col-md-5"
              style="margin-left: 0"
            >
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.addProduct.localGov") }}
                </span>
              </label>
              <div class="input__block">
                <select v-model="localGov[ind]">
                  <option :value="st" v-for="(st, i) in LGAs" :key="i">
                    {{ st.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-5">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.addProduct.deliveryHour") }}
                </span>
              </label>
              <div class="input__block" ref="c_inp">
                <input
                  type="number"
                  :placeholder="$t('text.addProduct.deliveryHour')"
                  class="form-control"
                  v-model="delivery[ind]"
                />
              </div>
              <div ref="c_err"></div>
            </div>
            <div class="block_6 col-md-1 delete_LGA">
              <img
                src="@/assets/img/remove (1).png"
                style="float: right; cursor: pointer"
                v-if="ind > 0"
                @click="deleteLGA(ind)"
              />
            </div>
          </div>
          <div class="mt-3 pb-3">
            <button class="add_more_btn" @click="addLocalGovernment">
              {{ $t("text.addProduct.addMore") }}
            </button>
          </div>
        </div>

        <div class="text-center mt-4 pb-4">
          <button
            class="save__btn"
            @click="addProduct($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
              isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' },
            ]"
          >
            {{ $t("text.addProduct.addProduct") }}<span></span>
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";

import JQuery from "jquery";
let $ = JQuery;

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

export default {
  title: "Add Product :: Epump Portal",
  name: "VerifyReceipt",
  components: {
    MasterLayout,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      selected: this.$t("text.addProduct.selectAProduct"),
      price: "",
      state: "",
      states: "",
      localGov: [],
      localGovernment: [],
      LGAs: "",
      prodArray: [],
      delivery: [],
      company: null,
      formIsValid: false,
      isButtonDisabled: false,
      showLoader: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if(this.$route.query.companyId){
      this.getStates();
      this.getProducts();
    }
  },
  mounted() {
    
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getStates();
        this.getProducts();
      }
    },
    state: function (newState, oldState) {
      this.getLGA(newState.id);
    },
  },
  methods: {
    addLocalGovernment() {
      this.localGovernment.push({});
      this.localGov.push({});
      this.delivery.push("");
    },
    deleteLGA(index) {
      this.localGov.splice(index, 1);
      this.localGovernment.splice(index, 1);
      this.delivery.splice(index, 1);
    },
    getLGA(stateId) {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/LGA/${stateId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.LGAs = response.data;
        });
    },
    getProducts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/Company/${this.$route.query.companyId ? this.$route.query.companyId :  this.company.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.isButtonDisabled = true;
          this.showLoader = false;
          this.prodArray = response.data;
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          
        });
    },
    getStates() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/States`,
          configObject.authConfig()
        )
        .then((response) => {
          this.localGov.push({});
          this.localGovernment.push({});
          this.delivery.push("");
          for (var x of response.data) {
            if (x.name.toLowerCase() === "lagos") {
              this.state = x;
              this.getLGA(x.id);
              break;
            }
          }
          this.states = response.data;
        })
        .catch((error) => {});
    },
    addProduct($event) {
      $event.preventDefault();
      if (typeof this.selected === "string") {
        this.$toast.open({
          message: this.$t("text.errors.productMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.price) {
        this.$toast.open({
          message: this.$t("text.errors.priceFieldMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.price <= 0) {
        this.$toast.open({
          message: this.$t("text.errors.invalidPrice"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      for (var x of this.localGov) {
        if (!x["id"]) {
          this.$toast.open({
            message: this.$t("text.addProduct.selectLGA"),
            type: "error",
            duration: 3000,
          });
          return;
        }
      }
      for (var x of this.delivery) {
        if (!x) {
          this.$toast.open({
            message: this.$t("text.addProduct.deliveryHourMissing"),
            type: "error",
            duration: 3000,
          });
          return;
        }
        if (x < 1) {
          this.$toast.open({
            message: this.$t("text.addProduct.invalidDeliveryHour"),
            type: "error",
            duration: 3000,
          });
          return;
        }
      }

      let lgAs = this.localGov.map((cur) => ({
        lgaId: cur.id,
        deliveryHours: "",
      }));
      this.delivery.forEach((cur, index) => {
        lgAs[index]["deliveryHours"] = parseInt(cur);
      });
      let data = {
        ...this.selected,
        price: parseInt(this.price),
        stateId: this.state.id,
        lgAs,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Delivery/Product`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$router.push({ name: "company_products", query: {companyId: this.$route.query.companyId} });
          this.$toast.open({
            message: this.$t("text.addProduct.successfullyAdded"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
  },
};
</script>
